<template>
  <v-container style="max-width:1200px" class="pt-0">
    <ASearchForm
      :modelName="modelName"
      :create="hasEditPermission"
      :dropdownProps="[{type:'text',name: 'Name (contains)', payloadKey: 'name'}]"
      @change="search"
      @create="onCreate"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <ADataTable
      :headers="headers"
      :api="api"
      :sort-by="'StartDate'"
      :sort-desc="false"
      :editAction="hasEditPermission"
      :deleteAction="hasEditPermission"
      :moveActions="hasEditPermission"
      @click:edit="onEdit"
      @click:delete="onDelete"
      :hideTitleBar="true"
      :apiParams="apiParams"
      ref="table"
    ></ADataTable>
    <AFormDialog
      ref="formDialog"
      :fields="formMeta"
      :modelName="modelName"
      :model="model"
      :updateOnlyChanged="true"
      @modified="load"
    ></AFormDialog>
  </v-container>
</template>

<script>
import snackbar from "../mixins/snackbar";
import ConfirmDialogMixin from "../mixins/ConfirmDialogMixin";
import crudFuncsMixin from "../mixins/CRUDFuncs";
import PermissionsHelper from "../mixins/PermissionsHelper";
import ASearchForm from "../components/ASearchForm";
import ADataTable from "../components/ADataTable";
import AFormDialog from "../components/AFormDialog";
import { time } from "../utils";

export default {
  name: "LineMoveDates",
  mixins: [snackbar, ConfirmDialogMixin, crudFuncsMixin, PermissionsHelper],
  components: {
    ASearchForm,
    ADataTable,
    AFormDialog
  },
  data() {
    return {
      model: "line-move-dates",
      modelName: "Line Move Date",
      headers: [
        { text: "Contract", value: "contractName" },        
        {
          text: "Start Date",
          value: "startDateFomatted",
          cusOrderByName: "startDate",
          format: {
            value: "startDate",
            formatter: v => {
              return time.toDateFormat1(v);
            }
          }
        },
        {
          text: "Finish Date",
          value: "finishDateFomatted",
          cusOrderByName: "finishDate",
          format: {
            value: "finishDate",
            formatter: v => {
              return time.toDateFormat1(v);
            }
          }
        },
      ],
      apiParams: {},
      formMeta: [
        {
            type: "dropdown",
            model: "contracts",
            label: "Contract*",
            queryParam: "contractId",
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "datepicker",
            label: "Start Date*",  
            queryParam: "startDate",
            readValueFormatter: v => { return time.toDateFormat2(v) },                    
            valueFormatter: v => { return v + "T00:00:00Z" },
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        },
        {
            type: "datepicker",
            label: "Finish Date*",    
            queryParam: "finishDate",
            readValueFormatter: v => { return time.toDateFormat2(v) },                  
            valueFormatter: v => { return v + "T00:00:00Z" },
            rules: [v => v !== undefined || "This field is mandatory"],
            updatable: true
        }
      ]
    };
  },
  updated() {
    this.load();
  },
  methods: {
    search(payload) {
      this.apiParams = payload;
    }
  }
};
</script>